export default {
  name: 'Validate',
  computed: {
    /**
     * 是否必填
     */
    required() {
      return this.rules ? this.rules.some(rule => rule.required) : false
    }
  },
  methods: {
    /**
     * 校验方法
     */
    validate() {
      // 校验结果
      let validateResult = true
      // 遍历所有规则
      this.rules && this.rules.forEach(rule => {
        // 如果校验成功
        if (validateResult) {
          // 如果当前是必填校验
          if (rule.required) {
            // 如果当前没有输入
            if (!this.value || this.value.length === 0) {
              this.validateCallback(validateResult = false, `请${this.$options.name === 'RnrInput' ? '输入' : '选择'}${this.label}`)
            }
          }
          // 如果当前是正则类型
          if (rule.test instanceof RegExp) {
            // 如果当前正则没匹配上
            if (!rule.test.test(this.value)) {
              // 如果方法没匹配上
              const message = rule.message || `${this.label}${this.$options.name === 'RnrInput' ? '输入' : '选择'}不合法，请重新${this.$options.name === 'RnrInput' ? '输入' : '选择'}`
              this.validateCallback(validateResult = false, message)
            }
          }
          // 如果当前是校验方法
          if (rule.validator instanceof Function) {
            // 校验结果
            const result = rule.validator(this.value)
            // 如果方法没匹配上
            if (
              (typeof result === 'boolean' && !result) ||
              (result instanceof Object && !result.result)
            ) {
              const message = result.message || `${this.label}${this.$options.name === 'RnrInput' ? '输入' : '选择'}不合法，请重新${this.$options.name === 'RnrInput' ? '输入' : '选择'}`
              this.validateCallback(validateResult = false, message)
            }
          }
        }
      })
      // 如果校验成功，则重置校验位
      if (validateResult) {
        this.validateCallback(true)
      }
      return validateResult
    },

    /**
     * 清空校验
     */
    clearValidate() {
      this.validateCallback(true)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/FormRender/mixins/validate.js